import { Container, makeStyles } from "@material-ui/core";
import ODS5 from './ODS5.svg';
import ODS16 from './ODS16.svg';
import ODS17 from './ODS17.svg';

export default function OdsPremisses() {

    const useStyles = makeStyles(() => ({
        root: {

            "@media (max-width: 576px)": {
                flexDirection: 'collumn'
            },
            "@media (max-width: 720px)": {
                flexDirection: 'collumn'
            },
            "@media (max-width: 960px)": {
                display: "flex",
                marginTop: '100px',
            },
            "@media (min-width: 1000px)": {
                display: "flex",
                marginTop: '100px',
            },
        },
        textH2: {
            padding: "10px"
        },
        textP: {
            padding: "10px"
        },
        imgContainer: {
            "@media (max-width: 576px)": {

                visibility: 'hidden',
                display: 'none'
            },
            "@media (max-width: 720px)": {
                visibility: 'hidden',
                display: 'none'
            },
            "@media (max-width: 999px)": {
                visibility: 'hidden',
                display: 'none'
            },
            "@media (min-width: 1000px)": {
                display: "grid",
                float: "right",
                width: "20%"
            },
        },
        paperText:{
            boxShadow: '0px 4px 30px #FBEAFF',
            alignSelf:"center",
            alignContent:"center",
            float:"center",
            "@media (max-width: 576px)": {

                width: "100%"
            },
            "@media (max-width: 720px)": {
                width: "100%"
            },
            "@media (mix-width: 960px)": {
                display: 'grid',
                float: "right"
            },

        },
        paperImg: {
            width: '200px',
            padding: "5px"
        }
    }));
    const classes = useStyles();

    return (
        <Container className={classes.root}>
            <Container className={classes.paperText} square>
                    <h2 className={classes.textH2}>Replicamos a tecnologia do Maria da Penha Virtual para atender a outras demandas e grupos vulneráveis</h2>
                    <p className={classes.textP}>O grupo Direito Ágil, formado por universitários de Direito e Sistemas da Informação,  tem se dedicado a desenvolver tecnologias voltadas à concretização do acesso à justiça para grupos vulneráveis, em compromisso com a Agenda 2030 para o Desenvolvimento Sustentável. Com uma formação multidisciplinar, o grupo pôde desenvolver, ainda em 2019, seu próprio método de trabalho, que conjuga densidade jurídica e probatória, automatização de fluxos processuais, replicabilidade, além da aplicação de técnicas de Legal Design e metodologia ágil ao processo.
                    </p>
                    <p className={classes.textP}>Busca-se pela tecnologia jurídica concretizar os Objetivos de Desenvolvimento Sustentável da ONU, especialmente os objetivos 16 (Paz, Justiça e Instituições Eficazes), 17 (Parcerias e Meios de Implementação) e mais um objetivo de acordo com o grupo vulnerável a ser atendido.</p>
                    <p className={classes.textP}>No caso prático do Maria da Penha Virtual, inclui-se o foco no atendimento do Objetivo 5 (igualdade de gênero), especificamente em seu item “5.b - Aumentar o uso de tecnologias de base, em particular as tecnologias de informação e comunicação, para promover o empoderamento das mulheres”.
                    </p>
                    <p className={classes.textP}>Em outras palavras, objetiva-se empoderar as mulheres em situação de violência doméstica para que possam, inclusive por meio de um smartphone, denunciar a agressão sofrida e pedir a medida protetiva pela via judicial, evitando o risco de revitimização, dado o atendimento desigual nas delegacias aos homens e mulheres, além de garantir o efetivo acesso à justiça e a redução da subnotificação.</p>
                    <p className={classes.textP}>Nesse sentido, o aplicativo Maria da Penha Virtual é a validação concreta do modelo teórico de concretização de direitos humanos concebido pelo grupo que pode ser replicável em larga escala e customizado com um design específico para a proteção de grupos vulneráveis, bem como para atender diversas outras demandas em que se vislumbra a tecnologia como solução para eliminar tarefas repetitivas em fluxos processuais.</p>
            </Container>
            <Container className={classes.imgContainer}>
                <img className={classes.paperImg} src={ODS5} alt="Simbolos da ODS 5, igualdade de genero" />
                <img className={classes.paperImg} src={ODS16} alt="Simbolo da ODS 16, paz,justiça e instituições eficazes" />
                <img className={classes.paperImg} src={ODS17} alt="Simbolo da ODS 17, Parcerias para alcançar objetivos" />
            </Container>
        </Container>
    );
}